import React from 'react'
import { useSelector } from 'react-redux'

import CircularProgress from '@mui/material/CircularProgress'
import { Box, Grid } from '@mui/material'
// import CircularProgress, { circularProgressClasses } from '@mui/material/CircularProgress'

const LoadingDialog = ({ type }) => {
  const loadingBarVisible = useSelector(state => state.loading[type])

  const GradientCircularProgress = () => (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            {/* <stop offset="0%" stopColor="#e01cd5" /> */}
            <stop offset="0%" stopColor="#F5290A" />
            {/* <stop offset="100%" stopColor="#1CB5E0" /> */}
            {/* <stop offset="100%" stopColor="#3DE01C" /> */}
            <stop offset="100%" stopColor="#D7E605" />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress size={100} sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} />
    </React.Fragment>
  )

  return (
    loadingBarVisible && (
      <Grid
        sx={{
          margin: '0',
          height: '100%',
          width: '100%',
          backgroundSize: '100%',
        }}
      >
        {/* <Grid maxWidth={'md'} maxHeight={'md'} sx={{margin:'0', backgroundSize: '100%', backgroundColor:'gray' }}> */}
        <Box sx={{ marginTop: '-30%', marginLeft: '50%', display: 'flex' }}>
          {/* <CircularProgress /> */}
          <GradientCircularProgress />
        </Box>
      </Grid>
    )
  )
}
export default LoadingDialog
